import type { RawMqttMessage } from '@/lib/mqtt/types';
import { useEffect, useRef } from 'react';

/** Bar chart of messages-per-second buckets for the selected topic buffer. */
export function HistoryChart({ messages }: { messages: RawMqttMessage[] }) {
  const ref = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const w = canvas.offsetWidth || 360;
    canvas.width = w;
    canvas.height = 180;

    // bucket the last 40 seconds by second
    const now = Date.now();
    const buckets = new Array<number>(40).fill(0);
    for (const m of messages) {
      const secAgo = Math.floor((now - m.receivedAt) / 1000);
      if (secAgo >= 0 && secAgo < 40) buckets[39 - secAgo]! += 1;
    }
    const max = Math.max(1, ...buckets);
    ctx.clearRect(0, 0, w, 180);
    const barW = (w - 20) / buckets.length;
    for (let i = 0; i < buckets.length; i++) {
      const b = buckets[i]!;
      const h = (b / max) * 160;
      ctx.fillStyle = i === buckets.length - 1 ? 'rgba(29,122,64,.7)' : 'rgba(29,122,64,.18)';
      ctx.fillRect(10 + i * barW, 170 - h, Math.max(1, barW - 1), h);
    }
  }, [messages]);

  return (
    <div className="flex-1 overflow-auto p-3">
      <div className="mb-2 font-sans text-[0.846em] text-(--color-text3)">
        Message rate over the last 40 s ({messages.length} buffered)
      </div>
      <canvas ref={ref} className="max-h-[180px] w-full" />
    </div>
  );
}
